import {
  BANNER_DATA,
  FEATURES,
  SECTION,
  COLLAPSIBLE_FEATURE_1,
  COLLAPSIBLE_FEATURE_2,
  TAB_FEATURE,
} from '@/utils/const/products/live-encoder';
import FullPageBanner, {
  ButtonGroup,
} from '@/components/commonComponents/fullPageBanner';
import FullPageFeature from '@/components/productPageComponents/fullPageFeature';
import { useUserAgentInfo } from '@/context/user-agent';
import FullPageSection from '@/components/productPageComponents/fullPageSection';
import FullPageCollapse from '@/components/productPageComponents/fullPageCollaspse';
import FullPageTab from '@/components/productPageComponents/fullPageTab';
import { useWebPResourceCompatibleFn } from '@/hooks/useWebPResource';
import { src } from '@/utils/common';
/**
 *
 * @description LiveEncoder 硬件编码器
 */

const LiveEncoder = () => {
  const { isMobile } = useUserAgentInfo();
  const webPResourceHandleFn = useWebPResourceCompatibleFn();

  const bannerData = isMobile
    ? BANNER_DATA
    : {
        ...BANNER_DATA,
        title: [BANNER_DATA.name, BANNER_DATA.title].join('，'),
        name: null,
      };

  return (
    <div>
      <FullPageBanner data={bannerData} />
      <FullPageFeature data={FEATURES} />
      <FullPageSection data={SECTION} scale={1.0} />
      <FullPageCollapse data={COLLAPSIBLE_FEATURE_1} imageAlign="left" />
      <FullPageCollapse
        data={COLLAPSIBLE_FEATURE_2}
        imageAlign="right"
        background={
          isMobile
            ? `center / cover no-repeat url(${webPResourceHandleFn(
                src('/img/products/live-encoder/section3-background.webp')
              )})`
            : '#F8F9FA'
        }
      />
      <FullPageTab data={TAB_FEATURE} />
      {isMobile && (
        <ButtonGroup
          data={{
            buttonText: BANNER_DATA.buttonText,
            businessLink: BANNER_DATA.businessLink,
          }}
        />
      )}
    </div>
  );
};

export default LiveEncoder;
